import React from "react";
import "./Programs.css";
import { programsData } from "../../data/programsData";
import {default as RightArrow} from '../../assets/rightArrow.png';
const Programs = () => {
  return (
    <div id="programs" className="Programs">
      {/* header */}
      <div className="programs-header">
        <span className="stroke">Explore our</span>
        <span>Programs</span>
        <span className="stroke">to shape you</span>
      </div>
      <div className="programs-catagories">
        {programsData.map((program) => (
          <div className="catagory">
            {program.image}
            <span>{program.heading}</span>
            <span>{program.details}</span>
            <div className="join-now">
              <span>Join Now</span>
              <img src={RightArrow} alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
